import {useEffect, useRef, useState} from "react";
import iconFileTextOutline from "@iconify/icons-eva/file-text-outline";
// import iconFileAddOutline from "@iconify/icons-eva/file-add-outline";
import iconPaperPlaneOutline from "@iconify/icons-eva/paper-plane-outline";
import MyPagination from "src/components/common/MyPagination";
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  Divider,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  DialogActions,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";
import {OrderListToolbar} from "../../components/_dashboard/order";

import axios from "axios";
import moment from "moment";
import {
  DELIVERY_TYPE_MAP,
  PAY_METHODS,
  PAY_METHOD_MAP,
  STORE_ORDER_STATUS,
  STORE_ORDER_STATUS_MAP,
} from "src/config/constants";
import {alert} from "src/services/alert";
import MoreMenu from "src/components/common/MoreMenu";
import XLSX from "xlsx";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import ConvertUtil from "src/utils/ConvertUtil";
import Confirm from "src/components/common/ConfirmDialog";
import ListHead from "src/components/common/ListHead";
import OrderRecordsDialog from "src/components/dialogs/OrderRecordsDialog";
import {asyncRequest} from "src/services/network";
import OrderDetailDialog from "src/components/dialogs/OrderDetailDialog";
import UserInfo from "src/components/common/UserInfo";
import CellImage from "src/components/common/CellImage";
import {Icon} from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/zh-cn";
import {DateTimePicker} from "@mui/x-date-pickers/DateTimePicker";
import StoreProductPicker from "src/components/common/StoreProductPicker";
import ListToolbar from "src/components/common/ListToolbar";
// ----------------------------------------------------------------------
const payMethods = Object.values(PAY_METHODS);
const statuses = Object.values(STORE_ORDER_STATUS);
const statusesList = ["", "1", "2", "3", "4", "5"];
const statusesWap = {
  1: "门票",
  2: "年会专区",
  3: "大项目部",
  4: "积分兑换",
  5: "低保领取",
};
const prizeTypeList = ["", "1", "2"];
const prizeTypeListTwo = ["1", "2"];
const prizeTypeWap = {
  1: "虚拟物品",
  2: "实物奖品",
};
const izEnabledList = ["", "true", "false"];
const izEnabledWap = {
  true: "是",
  false: "否",
};
const handleList = ["", "false", "true"];
const handleWap = {
  false: "未处理",
  true: "已处理",
};
const partyVersionList = ["202603", "202602", "202601"];
const partyVersionWrap = {
  202603: "2026马年七天乐",
  202602: "2026黄金答谢宴",
  202601: "2026云南旅游",
};
const prizeCodeList = ["smallGift", "pointsGreen", "xfq", "dhq", "ChineseGift", "jhq", "gold", "lockPoints", "bigGift"];
const prizeCodeNum = {
  smallGift: '奖品一',
  pointsGreen: '奖品二',
  xfq: '奖品三',
  dhq: '奖品四',
  ChineseGift: '奖品五',
  jhq: '奖品六',
  gold: '奖品七',
  lockPoints: '奖品八',
  bigGift: '奖品九',
};
const virtualTypeList = ["points", "coupon"];
const virtualTypeNum = {
  points: '积分',
  coupon: '卡券',
};
const prizeLevelList = ["1", "2", "3", "4", "5", "99", "100"];
const prizeLevelNum = {
  1: '一等奖',
  2: '二等奖',
  3: '三等奖',
  4: '四等奖',
  5: '五等奖',
  99: '其他普通奖品',
  100: '保底奖',
};
const TABLE_HEAD = [
  {
    id: "prizeCode",
    label: "奖品分类",
    alignRight: false,
  },
  {
    id: "prizeName",
    label: "奖品名称",
    alignRight: false,
  },
  {
    id: "prizeType",
    label: "奖品类型",
    alignRight: false,
  },
  {
    id: "prizeLevel",
    label: "奖品等级",
    alignRight: false,
  },
  {
    id: "prizeDesc",
    label: "奖品描述",
    alignRight: false,
  },
  {
    id: "prizeValue",
    label: "奖品价值",
    alignRight: false,
  },
  {
    id: "totalStock",
    label: "总库存数量",
    alignRight: false,
  },
  {
    id: "remainStock",
    label: "剩余库存数量",
    alignRight: false,
  },
  {
    id: "priceProbability",
    label: "价值占比",
    alignRight: false,
  },
  {
    id: "probability",
    label: "抽奖中奖概率",
    alignRight: false,
  },
  {
    id: "isEnabled",
    label: "是否启用",
    alignRight: false,
  },
  {
    id: "sortOrder",
    label: "排序",
    alignRight: false,
  },
  {
    id: "virtualType",
    label: "虚拟物品类型",
    alignRight: false,
  },
  {
    id: "couponCode",
    label: "卡券模板代码",
    alignRight: false,
  },
  {
    id: "partyVersion",
    label: "活动版本号",
    alignRight: false,
  },
  {
    id: "",
  },
];

const moreMenus = [
  {
    title: "编辑",
    icon: iconFileTextOutline,
  },
  // {title: "详情", icon: iconFileTextOutline},
  // {title: "记录", icon: iconFileTextOutline},
  // {title: "备注", icon: iconFileAddOutline},
  // {title: "发货", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  // // { title: "退款", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.REFUNDING] },
  // {title: "核销", icon: iconPaperPlaneOutline, limit: [STORE_ORDER_STATUS.PAYED]},
  // {
  //   title: "删除",
  //   icon: iconPaperPlaneOutline,
  //   limit: [STORE_ORDER_STATUS.FINISHED, STORE_ORDER_STATUS.DELETED, STORE_ORDER_STATUS.CANCELED]
  // },
];

export default function SupplierOrderList() {
  const [curOrder, setCurOrder] = useState({});
  const [action, setAction] = useState();
  const [remark, setRemark] = useState("");
  const [deliverySN, setDeliverySN] = useState(""); // 物流信息
  const [verifyCode, setVerifyCode] = useState(""); // 核销码
  const [orders, setOrders] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [countMap, setCountMap] = useState({});
  const [product, setProduct] = useState({});
  const [itemObj, setItemObj] = useState({});

  const uploadRef = useRef();
  const [form, setForm] = useState({
    id: '',
    // isShow: true,
    prizeCode: "",  //奖品分类
    prizeName: "",  //奖品名称
    prizeType: "",  //奖品类型
    prizeLevel: "",  //奖品等级
    prizeDesc: "",  //奖品描述
    prizeValue: "",  //奖品价值
    totalStock: "",  //总库存数量
    remainStock: "",  //剩余库存数量
    priceProbability: "",  //价值占比
    probability: "",  //抽奖中奖概率
    isEnabled: "true",  //是否启用
    sortOrder: "",  //排序
    virtualType: "",  //虚拟奖品类型
    couponCode: "",  //卡券码
    partyVersion: "",  //活动版本
  });
  const [filter, setFilter] = useState({
    page: 0,
    size: 20,
    status: [],
    payMethod: -1,
    search: "",
    productId: null,
    orderSN: "",
    receiverMobile: "",
    startTime: null,
    endTime: null,
    codeType: "",
    code: "",
    prizeType: "2",
    isEnabled: '',
    izUsed: "",
    uid: "",
    izProcess: "",
    partyVersion: "202603",
  });

  useEffect(() => {
    getOrders();
  }, [filter]);

  async function getOrders() {
    const result =
      (await asyncRequest({
        // path: "/store/order/list",
        path: "/meeting/2026/prizes",
        data: filter,
      })) || {};
    console.log(99999);
    console.log(result);
    const data = result.data || [];
    const count = result.count || 0;
    // const counts = result.counts || [];
    console.log(data);
    const counts = [];
    setOrders(
      data.map((d) => ({
        ...d,
        createdAt: moment(d.createdAt).format("YYYY-MM-DD HH:mm:ss"),
        // payTime: d.payTime ? moment(d.payTime).format("YYYY-MM-DD HH:mm:ss") : d.payTime,
        // productData: JSON.parse(d.productData) || [],
        // productName: JSON.parse(d.productData)[0].name,
      })),
    );
    setTotalItems(count);

    // const map = {};
    // for (let i = 0; i < counts.length; i++) {
    //   map[counts[i].status] = counts[i].count;
    // }
    // setCountMap(map);
  }

  function handleSearch(val) {
    setFilter({
      ...filter,
      search: val,
    });
  }

  const handleChangePage = (event, newPage) => {
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilter({
      ...filter,
      size: parseInt(event.target.value, 10),
      page: 1,
    });
  };
  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleSizeChange(value) {
    setFilter({
      ...filter,
      size: value,
    });
  }

  function handleDateChange(dateRange) {
    setFilter({
      ...filter,
      createdAt: dateRange,
    });
  }

  function handleStatusChange(status) {
    setFilter({
      ...filter,
      status,
    });
  }

  // 操作条
  async function handleDownload() {
    const {data, msg} = await asyncRequest({
      path: "/meeting/2026/codes/export",
      data: filter,
    });

    alert(msg, "success");
  }

  async function onUpdate() {
    // const { data, msg } = await asyncRequest({
    //   path: "/meeting/2026/codes/export",
    //   data: filter,
    // });

    // alert(msg, "success");
    Confirm({
      message: "确认更新中奖概率吗？",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/meeting/2026/probability/update",
          data: {
            partyVersion: filter.partyVersion,
          },
        });

        alert(msg, "success");
      },
    });
  }

  function exportOrders(orders) {
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const cellTitles = [
      "订单号",
      "收货人姓名",
      "收货人电话",
      "收货地址",
      "商品编号",
      "中奖名称",
      "数量",
      "下单时间",
      "支付状态",
      "支付时间",
      "用户备注",
      "管理员备注",
      "物流单号",
      "快递公司",
    ];
    const cellKeys = [
      "orderSN",
      "receiverName",
      "receiverMobile",
      "receiverAddress",
      "productId",
      "productName",
      "createdAt",
      "buyCount",
      "status",
      "payTime",
      "userRemark",
      "adminRemark",
      "deliverySN",
      "deliveryCompany",
    ];
    const header = alphabets.slice(0, cellTitles.length);

    const data = [{}];
    for (let i = 0; i < header.length; i++) {
      const alphabet = header[i];
      data[0][alphabet] = cellTitles[i];

      let j = 1;

      orders.forEach((order) => {
        let productIdx = 0;
        order.productData.forEach((product) => {
          if (!data[j]) {
            data[j] = {};
          }

          const obj = {
            ...order,
            productId: product.id,
            productName: product.name,
            status: ConvertUtil.getOrderStatusText(order.status),
            payMethod: PAY_METHOD_MAP[order.payMethod],
            count: product.count,
          };
          data[j][alphabet] = obj[cellKeys[i]];

          j++;
          productIdx++;
        });
      });
    }

    var ws = XLSX.utils.json_to_sheet(data, {
      header,
      skipHeader: true,
    });

    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, ws, "订单信息");

    XLSX.writeFile(workbook, `订单导出${Date.now()}.xlsx`);
  }

  function filterMoreMenus(status) {
    const menus = [];
    for (let i = 0; i < moreMenus.length; i++) {
      if (moreMenus[i].limit && !moreMenus[i].limit.includes(status)) {
        continue;
      }

      menus.push(moreMenus[i]);
    }

    return menus;
  }

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      page: 0,
      [ki]: val,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 20,
      status: [],
      payMethod: -1,
      productId: null,
      orderSN: "",
      receiverMobile: "",
      startTime: null,
      endTime: null,
      codeType: "",
      code: "",
      prizeType: "2",
      isEnabled: '',
      izUsed: "",
      uid: "",
      izProcess: "",
      partyVersion: "202603",
    });
  }

  async function getOrderRecords(orderSN) {
    const {data} = await asyncRequest({
      path: "/store/order/records",
      data: {
        orderSN,
      },
    });

    setRecords(data);
    setAction("records");
  }

  async function getOrderRecordstatus(orderSN) {
    const {data} = await asyncRequest({
      path: "/meeting/2026/codes/" + orderSN + "/process",
      data: {
        orderSN,
      },
    });
    getOrders();
  }

  async function getOrderRecordstatusTwo(item) {
    setItemObj(item);
    console.log(11111)
    console.log(item)
    setForm({
      id: item.id || '',
      // isShow: true,
      prizeCode: item.prizeCode || "",  //奖品分类
      prizeName: item.prizeName || "",  //奖品名称
      prizeType: item.prizeType || "",  //奖品类型
      prizeLevel: item.prizeLevel || "",  //奖品等级
      prizeDesc: item.prizeDesc || "",  //奖品描述
      prizeValue: item.prizeValue || "",  //奖品价值
      totalStock: item.totalStock || "",  //总库存数量
      remainStock: item.remainStock || "",  //剩余库存数量
      priceProbability: item.priceProbability || "",  //价值占比
      probability: item.probability || "",  //抽奖中奖概率
      isEnabled: item.isEnabled || "",  //是否启用
      sortOrder: item.sortOrder || "",  //排序
      virtualType: item.virtualType || "",  //虚拟奖品类型
      couponCode: item.couponCode || "",  //卡券码
      partyVersion: item.partyVersion || "",  //活动版本
    });
    setAction("tohandle");
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  // 更多操作
  function handleMoreClick(title, row, ...args) {
    if (title === "详情") {
      setCurOrder(row);
      setAction("detail");
    } else if (title === "记录") {
      // setAction("records");
      getOrderRecords(row.orderSN);
    } else if (title === "去处理") {
      // setAction("records");
      getOrderRecordstatus(row.orderSN);
    } else if (title === "发货") {
      setCurOrder(row);
      setAction("delivery");
    } else if (title === "备注") {
      setCurOrder(row);
      setRemark(row.adminRemark);
      setAction("remark");
    } else if (title === "核销") {
      // hexiao(row.orderSN);
      setCurOrder(row);
      setAction("hexiao");
    } else if (title === "删除") {
      delRow(row.orderSN);
    } else if (title === "确认支付") {
      confirmPay(row.orderSN);
    }
  }

  function Details(row) {
    getOrderRecordstatusTwo(row);
  }

  async function handleDialogConfirm() {
    if (action === "remark") {
      setAdminRemark();
    } else if (action === "delivery") {
      fahuo();
    } else if (action === "tohandle") {
      // 处理表单提交
      const dataToSubmit = {
        ...form,
      };
      // console.log("提交数据:", dataToSubmit);
      let result = await asyncRequest({
        path: "/meeting/2026/prizes/edit",
        data: {
          ...dataToSubmit,
        },
      });
      // 处理结果
      if (result.code == 1) {
        alert(result.msg, "success");
        getOrders(); // 刷新数据
        setAction(); // 关闭对话框
        resetForm(); // 重置表单
      }
    }
  }

  function resetForm() {
    setForm({
      id: '',
      // isShow: true,
      prizeCode: "",  //奖品分类
      prizeName: "",  //奖品名称
      prizeType: "",  //奖品类型
      prizeLevel: "",  //奖品等级
      prizeDesc: "",  //奖品描述
      prizeValue: "",  //奖品价值
      totalStock: "",  //总库存数量
      remainStock: "",  //剩余库存数量
      priceProbability: "",  //价值占比
      probability: "",  //抽奖中奖概率
      isEnabled: "",  //是否启用
      sortOrder: "",  //排序
      virtualType: "",  //虚拟奖品类型
      couponCode: "",  //卡券码
      partyVersion: "",  //活动版本
    });
  }

  async function handleConfirmHexiao() {
    const {data} = await asyncRequest({
      path: "/store/order/hexiao",
      data: {
        orderSN: curOrder.orderSN,
        verifyCode,
      },
    });

    getOrders();
    setAction();
  }

  async function setAdminRemark() {
    const {data} = await asyncRequest({
      path: "/store/order/remark",
      data: {
        orderSN: curOrder.orderSN,
        remark,
      },
    });

    orders.find((t) => t.orderSN === curOrder.orderSN).adminRemark = remark;
    setOrders([...orders]);

    setAction();
  }

  async function fahuo() {
    const {data} = await asyncRequest({
      path: "/store/order/fahuo",
      data: {
        orderSN: curOrder.orderSN,
        deliverySN: deliverySN,
      },
    });

    setOrders(orders.filter((t) => t.orderSN !== curOrder.orderSN));
    setAction();
    setDeliverySN("");
  }

  async function confirmPay(orderSN) {
    const {msg} = await asyncRequest({
      path: "/store/order/confirmPay",
      data: {
        orderSN,
      },
    });

    setOrders(orders.filter((t) => t.orderSN !== orderSN));
    alert(msg, "success");
  }

  function refund(orderSN) {
    Confirm({
      message: "确认退款吗？",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/refund",
          data: {
            orderSN,
          },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function delRow(orderSN) {
    Confirm({
      message: "确定删除该条数据吗?",
      async onConfirm() {
        const {data, msg} = await asyncRequest({
          path: "/store/order/del",
          data: {
            orderSN,
          },
        });

        setOrders(orders.filter((t) => t.orderSN !== orderSN));
        alert(msg, "success");
      },
    });
  }

  function handleUpload(e, type) {
    console.log(e);
    if (!e.target.files[0]) return;
    let reader = new FileReader();
    reader.onload = (event) => {
      uploadRef.current.value = null;
      try {
        // 判断文件类型是否正确
        // if (".xls" != suffix && ".xlsx" != suffix) {
        //     message.error("选择Excel格式的文件导入!");
        //     return false;
        // }
        let {result} = event.target;
        // 读取文件
        let workbook = XLSX.read(result, {
          type: "binary",
        });
        let data = [];
        // 循环文件中的每个表
        let loaded = false;
        for (let sheet in workbook.Sheets) {
          // console.log('sheet: ', sheet);
          // if (workbook.Sheets.hasOwnProperty(sheet)) {
          //   // 将获取到表中的数据转化为json格式
          // }
          if (loaded) continue;

          const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
            defval: "",
          });
          console.log(sheetData);
          // setInitialData(sheetData);
          // setShowImportDialog(true);
          if (type === "settle") {
            handleBulkSettle([...sheetData]);
          } else {
            handleBulkSend([...sheetData]);
          }
          loaded = true;
        }
        // console.log("data:", data);
      } catch (e) {
        console.log(e);
        alert("文件类型不正确！");
      }
    };
    reader.readAsBinaryString(e.target.files[0]);
    // console.log(e.target.files[0])
  }

  function handleBulkSend(items) {
    Confirm({
      message: "确定批量发货吗？",
      async onConfirm() {
        const orders = [];

        for (let index = 0; index < items.length; index++) {
          const order = items[index];

          if (!order["物流单号"]) continue;

          orders.push({
            orderSN: order["订单号"],
            deliverySN: order["物流单号"],
            deliveryCompany: order["物流公司"],
          });
        }

        console.log(orders, items);

        // return;

        const {msg} = await asyncRequest({
          path: "/store/order/bulkFahuo",
          data: {
            orders,
          },
        });

        alert(msg, "success");
        getOrders();
      },
    });
  }

  function handleBulkSettle(items) {
    Confirm({
      message: "确定批量设置对账状态吗？",
      async onConfirm() {
        const orders = [];
        for (let index = 0; index < items.length; index++) {
          const order = items[index];
          orders.push({
            orderSN: order["订单号"],
            isSettle: order["是否对账"],
          });
        }
        console.log(orders, items);
        const {msg} = await asyncRequest({
          path: "/store/order/bulk/settle",
          data: {
            orders,
          },
        });
        alert(msg, "success");
        getOrders();
      },
    });
  }

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - orders.length) : 0;
  const emptyRows = 0;

  return (
    <Page title="活动奖品">
      <Container maxWidth="2000px">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            活动奖品
          </Typography>

          <Button
            variant="contained"
            to="add"
            startIcon={<Icon icon={plusFill}/>}
            onClick={() => {
              setAction("tohandle");
            }}
          >
            添加奖品
          </Button>
        </Stack>
        <Card>
          <ListToolbar
            total={totalItems}
            countMap={countMap}
            onDateChange={handleDateChange}
            onStatusChange={handleStatusChange}
            onSearch={handleSearch}
            // onExport={handleDownload}
            onUpdate={onUpdate}
            onRefresh={getOrders}
            onReset={handleReset}
          >
            <Grid container gap={2}>
              {/* <Grid item>
                <TextField
                  style={{
                    width: 200,
                  }}
                  label="uid"
                  placeholder="uid"
                  autoComplete="off"
                  id="receiverMobile"
                  size="small"
                  value={filter.uid}
                  onChange={(evt) => {
                    handleFilterChange("uid", evt.target.value);
                  }}
                />{" "}
              </Grid> */}
              {/* <Grid item>
                <TextField
                  style={{
                    width: 200,
                  }}
                  label="抽奖码"
                  placeholder="抽奖码"
                  autoComplete="off"
                  id="orderSN"
                  size="small"
                  value={filter.code}
                  onChange={(e) => {
                    handleFilterChange("code", e.target.value);
                  }}
                />{" "}
              </Grid>{" "} */}
              {/* <Grid item>
                <FormControl size="small">
                  <InputLabel> 码类型 </InputLabel>{" "}
                  <Select
                    label="码类型"
                    value={filter.codeType}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        codeType: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {statusesList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : statusesWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "} */}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 奖品类型 </InputLabel>{" "}
                  <Select
                    label="奖品类型"
                    value={filter.prizeType}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        prizeType: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {prizeTypeList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : prizeTypeWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 是否启用 </InputLabel>{" "}
                  <Select
                    label="是否启用"
                    value={filter.isEnabled}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        isEnabled: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {izEnabledList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {idx === 0 ? "全部" : izEnabledWap[type]}
                      </MenuItem>
                    ))}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
              {/* <Grid item>
                <FormControl size="small">
                  <InputLabel> 处理标志 </InputLabel>{" "}
                  <Select
                    label="处理标志"
                    value={filter.izProcess}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        izProcess: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {handleList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {" "}
                        {idx === 0 ? "全部" : handleWap[type]}{" "}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "} */}
              <Grid item>
                <FormControl size="small">
                  <InputLabel> 活动类型 </InputLabel>{" "}
                  <Select
                    label="活动类型"
                    value={filter.partyVersion}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        partyVersion: e.target.value,
                      });
                    }}
                    style={{
                      width: 250,
                    }}
                  >
                    {partyVersionList.map((type, idx) => (
                      <MenuItem key={idx} value={type} name={type}>
                        {partyVersionWrap[type]}
                      </MenuItem>
                    ))}{" "}
                  </Select>{" "}
                </FormControl>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </ListToolbar>
          <Scrollbar>
            <TableContainer
              sx={{
                minWidth: 800,
              }}
            >
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {orders.map((row) => {
                    const {
                      id,
                      uid,
                      code,
                      payPrice,
                      payMethod,
                      prizeCode,
                      codeType,
                      prizeName,
                      prizeType,
                      prizeLevel,
                      prizeDesc,
                      prizeValue,
                      totalStock,
                      remainStock,
                      priceProbability,
                      probability,
                      isEnabled,
                      sortOrder,
                      virtualType,
                      partyVersion,
                      couponCode,
                      izProcess,
                      izUsed,
                      totalPrice,
                      buyCount,
                      productData,
                      createdAt,
                      status,
                      orderSN,
                      userRemark,
                      receiverAddress,
                      receiverName,
                      receiverMobile,
                      user,
                      rewardName,
                    } = row;
                    // const isItemSelected = selected.indexOf(nickname) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox">
                        <TableCell align="left" sx={{
                          minWidth: 100,
                        }}> {prizeCodeNum[prizeCode]} </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 170,
                          }}
                        >
                          {prizeName}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 100,
                          }}
                        >
                          <Stack>
                            <Typography>
                              {prizeType == 1
                                ? "虚拟物品"
                                : prizeType == 2
                                  ? "实物奖品"
                                  : ""}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 100,
                          }}
                        >
                          {prizeLevelNum[prizeLevel]}
                        </TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{prizeDesc}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 100,
                        }}>{prizeValue}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{totalStock == 0 ? "无限制" : totalStock}</TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: 120,
                          }}
                        >
                          {remainStock}
                        </TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{priceProbability}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{probability}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{isEnabled == true ? "已启用" : "未启用"}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{sortOrder}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{virtualType == 'points' ? "积分" : virtualType == 'coupon' ? "卡券" : ""}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{couponCode}</TableCell>
                        <TableCell align="left" sx={{
                          minWidth: 120,
                        }}>{partyVersion}</TableCell>
                        <TableCell
                          align="right"
                          sx={{
                            minWidth: 100,
                          }}
                        >
                          {/* {prizeType == 2 && izProcess == false ? ( */}
                          <Button variant="text" onClick={() => Details(row)}>
                            编辑
                          </Button>
                          {/* ) : (
                            ""
                          )} */}
                        </TableCell>{" "}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6}/>{" "}
                    </TableRow>
                  )}{" "}
                </TableBody>
                {orders.length === 0 && (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={6}
                        sx={{
                          py: 3,
                        }}
                      >
                        <SearchNotFound searchQuery={filter.search}/>{" "}
                      </TableCell>{" "}
                    </TableRow>{" "}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack
              direction="row"
              sx={{
                p: 2,
              }}
            >
              {" "}
              {/* <Typography variant="caption" component="span">
                      预期利润：{100}
                    </Typography>
                    <Divider orientation="vertical" flexItem sx={{mx: 1}} />
                    <Typography variant="caption" component="span" >
                      完单利润：{100}
                    </Typography> */}{" "}
            </Stack>{" "}
            {/* <TablePagination
              labelRowsPerPage="每页行数"
              rowsPerPageOptions={[10, 20]}
              component="div"
              count={totalItems}
              rowsPerPage={filter.size}
              page={filter.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />{" "} */}
            <MyPagination
              total={totalItems}
              page={filter.page}
              size={filter.size}
              onChange={handlePageChange}
              onSizeChange={handleSizeChange}
            />
          </Stack>{" "}
        </Card>{" "}
      </Container>
      {/* 详情 */}{" "}
      <OrderDetailDialog
        order={curOrder}
        open={action === "detail"}
        onClose={() => setAction()}
      />
      {/* 记录 */}{" "}
      <OrderRecordsDialog
        rows={records}
        open={action === "records"}
        onClose={() => setAction()}
      />
      <FormDialog
        title={`订单${curOrder.orderSN}备注`}
        open={action === "remark"}
        onConfirm={handleDialogConfirm}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="adminRemark"
          value={remark}
          label="管理员备注"
          fullWidth
          variant="standard"
          onChange={(e) => setRemark(e.target.value)}
        />{" "}
      </FormDialog>
      <FormDialog
        title={`订单${curOrder.orderSN}发货`}
        open={action === "delivery"}
        onConfirm={handleDialogConfirm}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="transport"
          value={deliverySN}
          label="物流单号"
          placeholder="(选填)"
          fullWidth
          variant="standard"
          onChange={(e) => setDeliverySN(e.target.value)}
        />{" "}
      </FormDialog>
      <FormDialog
        title={`订单${curOrder.orderSN}核销`}
        open={action === "hexiao"}
        onConfirm={handleConfirmHexiao}
        onClose={() => setAction()}
      >
        <TextField
          autoComplete="false"
          autoFocus
          id="transport"
          value={verifyCode}
          label="核销码"
          placeholder="(选填)"
          fullWidth
          variant="standard"
          onChange={(e) => setVerifyCode(e.target.value)}
        />{" "}
      </FormDialog>{" "}
      <FormDialog
        title={action === "tohandle" ? "编辑" : "新增"}
        open={action === "tohandle"}
        width={1200}
        onClose={() => {
          setAction();
          resetForm();
        }}
        onConfirm={handleDialogConfirm}
      >
        <FormItem title="商品ID">
          <TextField
            fullWidth
            placeholder="请输入商品ID"
            autoComplete="off"
            id="pid"
            disabled
            value={form.id || ""}
            size="small"
          />
        </FormItem>
        <FormItem title="奖品分类" required>
          <Select
            fullWidth
            value={form.prizeCode}
            onChange={(e) => handleIptChange("prizeCode", e.target.value)}
            size="small"
          >
            {prizeCodeList.map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {prizeCodeNum[type]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
        <FormItem title="奖品名称" required>
          <TextField
            fullWidth
            placeholder="请输入奖品名称"
            autoComplete="off"
            id="prizeName"
            value={form.prizeName || ""}
            onChange={(e) => handleIptChange("prizeName", e.target.value)}
            size="small"
          />
        </FormItem>
        <FormItem title="奖品类型" required>
          <Select
            fullWidth
            value={form.prizeType}
            onChange={(e) => handleIptChange("prizeType", e.target.value)}
            size="small"
          >
            {prizeTypeListTwo.map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {prizeTypeWap[type]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
        <FormItem title="奖品等级" required>
          <Select
            fullWidth
            value={form.prizeLevel}
            onChange={(e) => handleIptChange("prizeLevel", e.target.value)}
            size="small"
          >
            {prizeLevelList.map((type, idx) => (
              <MenuItem key={idx} value={type} name={type}>
                {prizeLevelNum[type]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
        <FormItem title="奖品描述">
          <TextField
            fullWidth
            placeholder="请输入奖品描述"
            autoComplete="off"
            id="prizeDesc"
            value={form.prizeDesc}
            size="small"
            multiline // 添加这个属性使其成为多行文本框
            rows={4} // 可以指定显示的行数，根据需要调整
            onChange={(e) => handleIptChange("prizeDesc", e.target.value)}
          />
        </FormItem>
        <FormItem title="奖品价值" required>
          <TextField
            fullWidth
            placeholder="请输入奖品价值"
            autoComplete="off"
            id="prizeValue"
            value={form.prizeValue || ""}
            size="small"
            type="number"
            onChange={(e) => handleIptChange("prizeValue", e.target.value)}
          />
        </FormItem>
        <FormItem title="总库存数量" required>
          <TextField
            fullWidth
            placeholder="请输入总库存数量"
            autoComplete="off"
            id="totalStock"
            value={form.totalStock || ""}
            size="small"
            type="number"
            onChange={(e) => handleIptChange("totalStock", e.target.value)}
          />
        </FormItem>
        <FormItem title="价值占比" required>
          <TextField
            fullWidth
            placeholder="请输入价值占比"
            autoComplete="off"
            id="priceProbability"
            value={form.priceProbability || ""}
            onChange={(e) => handleIptChange("priceProbability", e.target.value)}
            size="small"
            type="number"
          />
        </FormItem>
        <FormItem title="是否启用" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isEnabled}>
            <FormControlLabel value={true} control={<Radio/>} label="是"
                              onChange={(e) => handleIptChange("isEnabled", e.target.value)}/>
            <FormControlLabel value={false} control={<Radio/>} label="否"
                              onChange={(e) => handleIptChange("isEnabled", e.target.value)}/>
          </RadioGroup>
        </FormItem>
        {form.prizeType === "1" && (
          <FormItem title="虚拟奖品类型" required>
            <Select
              fullWidth
              value={form.virtualType}
              onChange={(e) => handleIptChange("virtualType", e.target.value)}
              size="small"
            >
              {virtualTypeList.map((type, idx) => (
                <MenuItem key={idx} value={type} name={type}>
                  {virtualTypeNum[type]}
                </MenuItem>
              ))}
            </Select>
          </FormItem>
        )}
        <FormItem title="卡券模板代码">
          <TextField
            fullWidth
            placeholder="请输入卡券模板代码"
            autoComplete="off"
            id="couponCode"
            value={form.couponCode || ""}
            onChange={(e) => handleIptChange("couponCode", e.target.value)}
            size="small"
            type="number"
          />
        </FormItem>
        <FormItem title="活动版本号" required>
          <TextField
            fullWidth
            placeholder="请输入活动版本号"
            autoComplete="off"
            id="partyVersion"
            value={form.partyVersion || ""}
            onChange={(e) => handleIptChange("partyVersion", e.target.value)}
            size="small"
            type="number"
          />
        </FormItem>
      </FormDialog>
    </Page>
  );
}
